import React, { useEffect, useState } from "react";
import {
  Container,
  EmptyList,
  UpdateButton,
  VehicleList,
  ButtonRow,
  VehicleButton,
} from "./WashingOperatorStyles";
import { WashingVehicle } from "../../types/carWashing.types";
import { getCarWashings, resetCarWashing } from "../../services/carWashingsService";
import { toast } from "react-toastify";
import { AppError } from "../../services/classes";
import { setLoading } from "../../stores/MainStore/MainStore";
import VehicleItem from "./components/VehicleItem/VehicleItem";
import VehicleModal from "./components/VehicleModal/VehicleModal";
import { useUnit } from "effector-react";
import { UserStore } from "../../stores/UserStore/UserStore";
import SearchPlate from "./components/SearchPlate/SearchPlate";

const WashingOperator: React.FC = () => {
  const [vehicleList, setVehicleList] = useState<WashingVehicle[]>();
  const [activePlate, setActivePlate] = useState<string>("");
  

  const { station } = useUnit(UserStore);

  useEffect(() => {
    handleGetCarWashings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetCarWashings = () => {
    if (!station) {
      toast.error("Usuário sem station");
      return;
    }

    setLoading(true);

    getCarWashings(station)
      .then((res) => setVehicleList(res))
      .catch((err: AppError) => {
        console.log(err.message);
        toast.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleResetCarWashing = (id: string) => {
    setLoading(true);
    resetCarWashing(id)
      .then(() => {
        toast.success("Máquina resetada com sucesso");
        handleGetCarWashings();
      })
      .catch((err: AppError) => {
        console.log(err.message);
        toast.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderList = () => {
    const filteredEmpty = vehicleList?.filter((vehicle) => vehicle.plate);
    const filtered = filteredEmpty?.filter(
      (vehicle) => vehicle.plate !== "Desconhecida"
    );

    if (!filtered?.length) {
      return <EmptyList>Nenhum veículo encontrado</EmptyList>;
    }

    return filtered?.map((vehicle) => {
      if (!vehicle.plate) return <></>;

      return (
        <VehicleItem
          key={vehicle.plate}
          plate={vehicle.plate}
          clientName={vehicle.clientName}
          fleetDescription={vehicle.fleetDescription}
          status={vehicle.status}
          setActivePlate={setActivePlate}
        />
      );
    });
  };

  const renderButtons = () => {
    if (!vehicleList || vehicleList.length === 0) return null;

    return (
      <ButtonRow>
        {vehicleList.map((v, i) => (
          <VehicleButton
            key={v.id}
            $highlight={(v.step ?? 0) > 6}
            onClick={() => resetCarWashing(v.id).then(() => {
              toast.success("Máquina resetada com sucesso");
              handleGetCarWashings();
            })
              .catch((err: AppError) => {
                console.log(err.message);
                toast.error(err.message);
              })}
          >
            Reset {i + 1}
          </VehicleButton>
        ))}
      </ButtonRow>
    );
  };

  return (
    <Container>
      <VehicleList>{renderList()}</VehicleList>
      <UpdateButton onClick={handleGetCarWashings}>Atualizar</UpdateButton>

      {renderButtons()}
      <SearchPlate setActivePlate={setActivePlate} />

      {activePlate && (
        <VehicleModal
          activePlate={activePlate}
          setActivePlate={setActivePlate}
          numberOfMachines={vehicleList?.length || 0}
        />
      )}
    </Container>
  );
};

export default WashingOperator;
